import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { CorreoService } from '../../services/correo/correo.service';
import { CorreoRequest } from '../../models/correo/correo-request.model';
import { ReportService } from '../../services/report/report.service';
import { firstValueFrom } from 'rxjs';
import { PasoCertificado } from '../../shared/enums/PasoCertificado';
import { RetefuenteService } from '../../services/retefuente/retefuente.service';
import { DescargasService } from '../../services/descargas/createTokenRequest.service';
import { SendMessageRequest } from '../../models/wolkvox/SendMessageRequest';
import { SendMessageService } from '../../services/wolkvox/sendmessage.service';
import { AuthService } from '../../services/security/auth.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';

@Component({
  selector: 'app-modal-certificados',
  templateUrl: './modal-certificados.component.html',
  styleUrls: ['./modal-certificados.component.css']
})
export class ModalCertificadosComponent implements OnInit {

  formCertificado: FormGroup;
  usuarios: any[] = [];
  pdfBlob: Blob | null = null;
  pdfBase64: string | null = null;
  loadingPdf = false;
  paso: PasoCertificado = PasoCertificado.Tipo;
  PasoCertificado = PasoCertificado;
  listaAnios: Array<{ value: number, label: string }> = [];
  titular: any | null = null;
  codCorreo: string = "";
  fileName: string = "";
  tipoCertificado: string = "";
  loadingWhatsapp = false
  todosSeleccionados = false;
  indeterminate = false;
  contratante: any;
  logInfo: any;
  cedulaAsesor: any;
  loggedUser: any;
  nombre_Asesor: any;
  trackDataEnviar!: TrackData;

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private correoService: CorreoService,
    private retefuenteService: RetefuenteService,
    private createTokenRequest: DescargasService,
    private sendMessageService: SendMessageService,
    public dialogRef: MatDialogRef<ModalCertificadosComponent>,
    private authService: AuthService,
    private trackingService: TrackingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.usuarios = data.usuario || [];

    const map = new Map<string, any>();

    for (const u of this.usuarios) {
      const raw = (u.identificacion || '').trim();
      const [tipoDocRaw, numDocRaw] = raw.split('-').map((x: string) => x.trim());

      const tipoDoc = (numDocRaw ? tipoDocRaw : '');
      const numDoc = (numDocRaw ? numDocRaw : raw);

      const u2 = { ...u, tipoDoc, numDoc };

      if (!map.has(numDoc)) map.set(numDoc, u2);
    }

    this.usuarios = Array.from(map.values());

    this.titular = this.getTitularReal();

    this.formCertificado = this.fb.group({
      tipoCertificado: ['', Validators.required],
      usuariosSeleccionados: this.fb.array([], Validators.required),
      year: [null],
      medioEnvio: ['', Validators.required],
      email: [''],
      whatsapp: ['']
    });
  }

  async ngOnInit(): Promise<void> { 
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    console.log('userCC:', this.cedulaAsesor);

    this.trackDataEnviar = {
      module: 'Mi población',
      category: 'N/A',
      submodule: 'Consulta mis usuarios población',
      functionality: '',
      cedulaAsesor: this.cedulaAsesor,
      identificadorInteraccion: ''
    };
  }


  onTipoCertificadoChange(value: string): void {
    console.log('Tipo certificado seleccionado:', value);

    if (value === 'Afiliación') {
      this.trackDataEnviar = {
        ...this.trackDataEnviar,
        functionality: 'Generar certificado de afiliación',
        identificadorInteraccion: 'POB_CONSULTA_USU_POB_GENERAR_AFILIACION',
        fechaInteraccion: this.getCurrentTimestamp()
      };
    } else if (value === 'Retefuente') {
      this.trackDataEnviar = {
        ...this.trackDataEnviar,
        functionality: 'Generar certificado de retefuente',
        identificadorInteraccion: 'POB_CONSULTA_USU_POB_GENERAR_RETEFUENTE',
        fechaInteraccion: this.getCurrentTimestamp()
      };
    }

    console.log('TrackData actualizado:', this.trackDataEnviar);
  }

  get usuariosArr() {
    return this.formCertificado.get('usuariosSeleccionados') as FormArray;
  }

  public esAfiliacion(): boolean {
    return (this.formCertificado.value.tipoCertificado || '').toLowerCase() === 'afiliación';
  }

  public esRetefuente(): boolean {
    return (this.formCertificado.value.tipoCertificado || '').toLowerCase() === 'retefuente';
  }

  onCheckboxChange(e: any, usuario: any) {
    if (e.checked) {
      const yaExiste = this.usuariosArr.controls.some(
        x => x.value.numDoc === usuario.numDoc
      );

      if (!yaExiste) {
        this.usuariosArr.push(new FormControl(usuario));
      }
    } else {
      const index = this.usuariosArr.controls.findIndex(
        x => x.value.numDoc === usuario.numDoc
      );

      if (index !== -1) {
        this.usuariosArr.removeAt(index);
      }
    }

    this.actualizarEstadoSeleccionarTodos();
  }

  seleccionarTodos(e: any) {
    this.usuariosArr.clear();

    if (e.checked) {
      this.usuarios.forEach(user => {
        this.usuariosArr.push(new FormControl(user));
      });
    }

    this.actualizarEstadoSeleccionarTodos();
  }

  isUsuarioSelected(usuario: any): boolean {
    return this.usuariosArr.value.some((x: any) => x.identificacion === usuario.identificacion);
  }

  async siguiente() {
    if (this.paso === PasoCertificado.Tipo) {

      const tipo = this.formCertificado.value.tipoCertificado;
      if (!tipo) return;

      if (tipo === 'Afiliación') {
        this.paso = PasoCertificado.AfiliacionUsuarios;
        return;
      }

      if (tipo === 'Retefuente') {
        await this.cargarAniosRetefuente();
        this.paso = PasoCertificado.RetefuenteAnio;
        return;
      }
    }


    if (this.paso === PasoCertificado.AfiliacionUsuarios) {
      try {
        this.loadingPdf = true;

        this.codCorreo = 'P035';
        this.fileName = 'certificado-afiliacion.pdf';
        this.tipoCertificado = "afiliación";

        const body = this.buildBodyCertificadoAfiliacion();

        const blob = await firstValueFrom(
          this.reportService.generarCertificadoAfiliacion(body)
        );

        if (!blob) throw new Error('El backend no devolvió el PDF.');

        this.pdfBlob = blob;
        this.pdfBase64 = await this.blobToBase64(blob);

        this.prepararDatosEnvio();

        this.paso = PasoCertificado.MedioEnvio;

      } catch (err) {
        console.error('Error generando PDF:', err);
      } finally {
        this.loadingPdf = false;
      }
      return;
    }


    if (this.paso === PasoCertificado.RetefuenteAnio) {

      try {
        this.loadingPdf = true;

        this.codCorreo = 'P036';
        this.fileName = 'certificado-retefuente.pdf';
        this.tipoCertificado = "retención en la fuente";

        const body = this.buildBodyCertificadoRetefuente();

        const blob = await firstValueFrom(
          this.reportService.generarCertificadoRetefuente(body)
        );

        if (!blob) throw new Error('El backend no devolvió el PDF.');

        this.pdfBlob = blob;
        this.pdfBase64 = await this.blobToBase64(blob);

        this.prepararDatosEnvio();

        this.paso = PasoCertificado.MedioEnvio;

      } catch (err) {
        console.error('Error generando PDF:', err);
      } finally {
        this.loadingPdf = false;
      }

      return;
    }
  }

  prepararDatosEnvio() {
    const titularReal = this.getTitularReal();

    let telefono = '';

    if (titularReal) {
      telefono = (titularReal.Telefono || '').trim();
    } else {
      const seleccionado = this.usuariosArr.value?.[0];
      telefono = (seleccionado?.Telefono || '').trim();
    }
    if (this.esRetefuente()) {
      const emailTitular = (this.titular?.email || '').trim();
      console.log("Este es el telefono del titular: ", telefono)
      this.formCertificado.patchValue({
        email: emailTitular,
        whatsapp: telefono
      });
      return;
    }
    const emails = this.getEmailsSeleccionados();
    console.log("Este es el telefono del titular: ", telefono)
    this.formCertificado.patchValue({
      email: emails.join(','),
      whatsapp: telefono
    });
  }

  get nombresSeleccionados(): string {
    const seleccion = this.usuariosArr.value;
    if (seleccion.length === this.usuarios.length) return 'todos los usuarios';
    return seleccion.map((u: any) => u.nombre).join(', ');
  }

  private getEmailsSeleccionados(): string[] {
    const seleccion = this.usuariosArr.value || [];
    return Array.from(
      new Set(
        seleccion
          .map((u: any) => (u.email || '').trim())
          .filter((e: string) => !!e)
      )
    );
  }

  async enviar() {

    const medio = this.formCertificado.value.medioEnvio;

    if (medio === 'whatsapp') {
      this.loadingWhatsapp = true;

      console.log("Entro aquí al envío por wahtsapp")

      const link = await this.getLink();

      if (!link) {
        console.error('No hay link de WhatsApp generado.');
        return;
      }

      this.sendMessage(link)

      this.loadingWhatsapp = false;

      this.paso = PasoCertificado.Confirmacion;
      return;
    }


    const emails = (this.formCertificado.value.email || '').trim();

    console.log('PDF Blob:', this.pdfBlob, 'type:', this.pdfBlob?.type, 'size:', this.pdfBlob?.size);
    if (!this.pdfBlob) throw new Error('Error generando el pdf en el servidor');

    this.pdfBase64 = await this.blobToBase64(this.pdfBlob);

    if (!emails.length) {
      console.error('No hay correos válidos en los usuarios seleccionados');
      return;
    }

    const correoRequest: CorreoRequest = {
      from: 'no-responder@coomeva.com.co',
      to: emails,
      cc: '',
      codCorreo: this.codCorreo,
      jsonParametros: JSON.stringify({}),
      attachments: [
        {
          fileName: this.fileName,
          mimeType: '.pdf',
          fileContent: this.pdfBase64
        }
      ]
    };

    this.correoService.enviarCorreo(correoRequest).subscribe({
      next: () => {
        console.log('Correo enviado exitosamente');
        this.paso = PasoCertificado.Confirmacion;
      },
      error: (error) => {
        console.error('Error al enviar el correo:', error);
      }
    });
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const dataUrl = reader.result as string;
        resolve(dataUrl.split(',')[1]);
      };
      reader.readAsDataURL(blob);
    });
  }

  private buildBodyCertificadoAfiliacion(): any {
    const titular = this.resolverTitularAfiliacion();

    if (!titular?.numDoc) {
      throw new Error('No se encontró el titular o no tiene numDoc.');
    }


    const seleccion = this.usuariosArr.value || [];
    const detail = Array.from(
      new Set(
        seleccion
          .map((u: any) => u.numDoc)
          .filter((x: string) => !!x)
      )
    ).join(',');

    if (!detail) {
      throw new Error('No hay usuarios seleccionados para generar el certificado.');
    }

    return {
      params: [
        { nombre: 'id', valor: titular.numDoc },
        { nombre: 'tipo_id', valor: titular.tipoDoc || 'CC' },
        { nombre: 'detail', valor: detail }
      ],
      outputType: 'PDF',
      outputFormat: 'BYTES',
      pdfPassword: '123456'
    };
  }

  private buildBodyCertificadoRetefuente(): any {
    const year = this.formCertificado.value.year;

    const document = this.titular.numDoc;
    const fullName = this.titular.nombre;

    if (!year) return;

    return {
      params: [
        { nombre: 'id', valor: document },
        { nombre: 'name', valor: fullName },
        { nombre: 'anio', valor: year }
      ],
      outputType: 'PDF',
      outputFormat: 'BYTES',
      pdfPassword: '123456'
    };
  }

  private async cargarAniosRetefuente() {
    try {
      const res: any = await firstValueFrom(this.retefuenteService.getYears());
      if (res?.listaAnios?.length) {
        this.listaAnios = res.listaAnios.map((x: any) => ({
          value: x.anio,
          label: String(x.anio)
        }));
      } else {
        console.error('El servicio no devolvió listaAnios:', res);
        this.listaAnios = [];
      }
    } catch (e) {
      console.error('Error cargando años retefuente', e);
      this.listaAnios = [];
    }
  }

  async getLink(): Promise<string> {
    const seleccion = this.usuariosArr.value || [];
    const detail = Array.from(
      new Set(
        seleccion
          .map((u: any) => u.numDoc)
          .filter((x: string) => !!x)
      )
    ).join(',');

    try {

      if (!this.esRetefuente()) {
        const titularAfiliacion = this.resolverTitularAfiliacion();

        if (!titularAfiliacion?.numDoc) {
          throw new Error('No se encontró titular o contratante para afiliación.');
        }

        const documento = titularAfiliacion.numDoc;
        const nombre = titularAfiliacion.nombre;
        const tipoDocumento = titularAfiliacion.tipoDoc;

        const tipoCertificado = 'afiliaciones';
        const anio = "";
        const ttlDias = 7;

        const resp: any = await firstValueFrom(
          this.createTokenRequest.crearTokenDescarga({
            documento,
            tipoDocumento,
            anio,
            nombre,
            tipoCertificado,
            ttlDias,
            detail
          })
        );

        let token = "";

        if (!token && typeof resp === 'string') {
          const parsed = JSON.parse(resp);
          if (parsed?.token) token = parsed.token;
        }

        if (!token) {
          throw new Error('El backend no devolvió token.');
        }

        console.log('Este el token: ' + token)

        const baseFront = window.location.origin;
        const url = `${baseFront}/ova-pre/#/descargas/${token}`;

        return url;
      }

      const titularReal = this.getTitularReal();

      if (!titularReal?.numDoc) {
        throw new Error('No se encontró titular real para retefuente.');
      }

      const anio = this.formCertificado.value.year;
      if (!anio) {
        throw new Error('Debe seleccionar el año.');
      }

      const documento = titularReal.numDoc;
      const nombre = titularReal.nombre;
      const tipoCertificado = 'retefuente';
      const ttlDias = 7;

      const resp: any = await firstValueFrom(
        this.createTokenRequest.crearTokenDescarga({
          documento,
          anio,
          nombre,
          tipoCertificado,
          ttlDias
        })
      );

      let token = "";

      if (!token && typeof resp === 'string') {
        const parsed = JSON.parse(resp);
        if (parsed?.token) token = parsed.token;
      }

      if (!token) {
        throw new Error('El backend no devolvió token.');
      }

      console.log('Este el token: ' + token)

      const baseFront = window.location.origin;
      const url = `${baseFront}/ova-pre/#/descargas/${token}`;

      return url;

    } catch (error) {

      console.error('Error generando link:', error);
      throw error;

    } finally {

      this.loadingWhatsapp = false;

    }
  }

  sendMessage(link: string) {
    let persona: any;
    let telefono = '';

    if (this.esRetefuente()) {
      persona = this.titular;
      telefono = (persona?.Telefono || '').trim();

    } else {

      const titularReal = this.getTitularReal();

      if (titularReal) {

        persona = titularReal;
        telefono = (titularReal.Telefono || '').trim();
      } else {
        const seleccionado = this.usuariosArr.value?.[0];

        persona = seleccionado;
        telefono = (seleccionado?.Telefono || '').trim();
      }
    }

    if (!persona?.nombre || !persona?.numDoc) {
      console.error('No se encontró persona válida para enviar WhatsApp');
      return;
    }

    if (!telefono) {
      console.error('No se encontró teléfono para enviar WhatsApp');
      return;
    }

    const nameParts = persona.nombre.trim().split(/\s+/);
    const lastName = nameParts.slice(0, 2).join(' ');
    const firstName = nameParts.slice(2).join(' ');

    const request: SendMessageRequest = {
      customer_name: firstName,
      customer_last_name: lastName,
      customer_id: persona.numDoc,
      opt_1: this.tipoCertificado,
      opt_2: link,
      opt_3: "",
      opt_4: "",
      opt_5: "",
      campaign_id: "11083",
      tel1: "9" + telefono
    };

    this.sendMessageService.sendMessage(request).subscribe({
      next: (resp) => {
        if (resp.data && resp.data.length > 0) {
          resp.message = "No fue posible enviar el mensaje";
        }
      },
      error: (err) => {
        console.error(err);
      },
    });

  }

  private resolverTitularAfiliacion(): {
    numDoc: string;
    tipoDoc: string;
    nombre: string;
    telefono: string;
    email: string;
  } | null {
    const titularLista = this.getTitularReal();

    if (titularLista) {
      return {
        numDoc: titularLista.numDoc,
        tipoDoc: titularLista.tipoDoc || 'CC',
        nombre: titularLista.nombre || '',
        telefono: titularLista.Telefono || '',
        email: titularLista.email || ''
      };
    }

    const contratanteRaw = (this.usuarios?.[0]?.Contratante || '').trim();
    if (!contratanteRaw) return null;

    const match = contratanteRaw.match(/^([A-Za-z]+)\s*-\s*(\d+)\s*(.*)$/);
    if (!match) return null;

    return {
      tipoDoc: match[1].trim(),
      numDoc: match[2].trim(),
      nombre: match[3].trim(),
      telefono: this.usuarios?.[0]?.Telefono || '',
      email: this.usuarios?.[0]?.email || ''
    };
  }

  get puedeGenerarRetefuente(): boolean {
    return !!this.getTitularReal();
  }

  private getTitularReal(): any | null {
    return this.usuarios.find(
      u => (u.ParentescoReal || '').toLowerCase().trim() === 'titular'
    ) || null;
  }

  private actualizarEstadoSeleccionarTodos(): void {
    const totalUsuarios = this.usuarios.length;
    const totalSeleccionados = this.usuariosArr.length;

    this.todosSeleccionados = totalUsuarios > 0 && totalSeleccionados === totalUsuarios;
    this.indeterminate = totalSeleccionados > 0 && totalSeleccionados < totalUsuarios;
  }
  
  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  cerrar() {
    this.dialogRef.close();
  }
}